import { render } from "./RuiTask.vue?vue&type=template&id=8ddfb54c"
const script = {}
script.render = render

export default script